export const LS_KEY_ORGANISATION = 'uitleenloket-organisation';
